import React, { useEffect, useState, useCallback } from "react";
import { useLocation, useParams } from "react-router-dom";
import dbService from "../../../../firebase/dbService";
import SchoolDetails from "../components/SchoolDetails";

import {
  AuthShowcaseSlider,
  ForgotPasswordForm,
  IndividualEmailFlow,
  IndividualPhoneFlow,
} from "./components";

const IndividualRegisterForm = () => {
  const location = useLocation();
  const { schoolId } = useParams();
  const searchParams = new URLSearchParams(location.search);
  const isAiLab = searchParams.get("source") === "ai-lab";
  const demoType = searchParams.get("type");

  const isForgotPassword = location.pathname.includes("forgotPassword");
  const isEmailMode =
    location.pathname.endsWith("/email") ||
    location.pathname === "/register/email" ||
    location.pathname === "/login/email";

  const [schoolDetails, setSchoolDetails] = useState(null);

  useEffect(() => {
    const fetchSchoolDetails = async () => {
      try {
        const data = await dbService.getdocument("schools", schoolId);
        if (data) {
          setSchoolDetails(data);
        }
      } catch (error) {
        console.log(error);
      }
    };
    if (schoolId) fetchSchoolDetails();
  }, [schoolId]);

  const getDashboardTargetUrl = useCallback(() => {
    if (demoType) return `/dashboard${location.search}`;
    if (isAiLab) return "/dashboard?offer=ai-lab";
    return "/dashboard";
  }, [demoType, location.search, isAiLab]);

  return (
    <>
      {schoolDetails && <SchoolDetails details={schoolDetails} />}

      <div className="grid grid-cols-1 lg:grid-cols-10 gap-6 items-stretch mt-4 xl:px-12 2xl:px-20 max-w-[1440px] mx-auto w-full">
        {/* Left Column: Form Content */}
        <div className="lg:col-span-4 w-full h-full flex flex-col">
          <div className="bg-white border border-gray-100 rounded-[2rem] p-6 sm:p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] h-full flex flex-col justify-start">
            {isForgotPassword ? (
              <ForgotPasswordForm />
            ) : isEmailMode ? (
              <IndividualEmailFlow getDashboardTargetUrl={getDashboardTargetUrl} />
            ) : (
              <IndividualPhoneFlow getDashboardTargetUrl={getDashboardTargetUrl} />
            )}
          </div>
        </div>

        {/* Right Column: Shared Showcase Slider (Image 2) */}
        <AuthShowcaseSlider />
      </div>
    </>
  );
};

export default IndividualRegisterForm;
